<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="处理方式" prop="handleType">
        <a-radio-group button-style="solid" v-model="form.handleType" @change="handleTypeChange">
          <a-radio-button :value="0"> 维修 </a-radio-button>
          <a-radio-button :value="1"> 换新 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <!-- 换新时才显示新设备MAC地址 -->
      <a-form-model-item v-if="form.handleType === 1" label="新设备MAC地址" prop="newMacAddress">
        <a-input
          v-model="form.newMacAddress"
          placeholder="请输入新设备MAC地址，格式：XX:XX:XX:XX:XX:XX（仅换新时必填）"
          :maxLength="17"
          @input="formatMacAddress"
        />
      </a-form-model-item>

      <a-form-model-item label="处理人姓名" prop="processorName">
        <a-input v-model="form.processorName" placeholder="请输入处理人姓名" :maxLength="50" />
      </a-form-model-item>

      <a-form-model-item label="故障原因" prop="faultCause">
        <a-textarea v-model="form.faultCause" placeholder="请输入故障原因" :rows="3" :maxLength="200" />
      </a-form-model-item>

      <a-form-model-item label="维修内容" prop="repairContent">
        <a-textarea v-model="form.repairContent" placeholder="请输入维修内容" :rows="3" :maxLength="200" />
      </a-form-model-item>

      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入备注" :rows="2" :maxLength="150" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { completeRepair } from '@/api/fix/devRepair'

export default {
  name: 'CompleteRepair',
  data() {
    return {
      submitLoading: false,
      formTitle: '设备返修-维修完成',
      open: false,
      showLoading: false,

      // 表单参数
      form: {
        id: undefined,
        handleType: 0, // 默认维修
        newMacAddress: '',
        processorName: '',
        faultCause: '',
        repairContent: '',
        returnMailNo: '',
        remark: '',
      },

      rules: {
        handleType: [{ required: true, message: '请选择处理方式', trigger: 'change' }],
        processorName: [{ required: true, message: '请输入处理人姓名', trigger: 'blur' }],
        newMacAddress: [
          {
            validator: (rule, value, callback) => {
              // 如果是换新（handleType === 1），则必填
              if (this.form.handleType === 1) {
                if (!value || value.trim() === '') {
                  callback(new Error('换新时请输入新设备MAC地址'))
                  return
                }
                // 验证MAC地址格式：XX:XX:XX:XX:XX:XX
                const macPattern = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
                if (!macPattern.test(value)) {
                  callback(new Error('MAC地址格式不正确，应为XX:XX:XX:XX:XX:XX'))
                  return
                }
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
        faultCause: [{ required: false, message: '请输入故障原因', trigger: 'blur' }],
        repairContent: [{ required: false, message: '请输入维修内容', trigger: 'blur' }],
        returnMailNo: [{ required: false, message: '请输入邮寄回单号', trigger: 'blur' }],
      },
    }
  },
  methods: {
    onCloseConfirm(callback) {
      const that = this
      this.$confirm({
        title: '是否确认关闭？未保存的数据将丢失',
        onOk() {
          callback && callback()
          that.reset()
        },
        onCancel() {},
      })
    },

    // 格式化MAC地址输入
    formatMacAddress(e) {
      let value = e.target ? e.target.value : e
      if (!value) {
        this.form.newMacAddress = ''
        return
      }
      // 移除非十六进制字符（保留冒号和横线）
      value = value.replace(/[^0-9A-Fa-f:-\s]/g, '')
      // 移除所有分隔符和空格，只保留纯数字和字母
      const cleanValue = value.replace(/[:-\s]/g, '').toUpperCase()
      // 限制最多12个字符（6组，每组2个字符）
      const limitedValue = cleanValue.substring(0, 12)
      // 每2个字符添加一个冒号
      const formatted = limitedValue.match(/.{1,2}/g) || []
      const result = formatted.join(':')
      // 更新表单值
      this.form.newMacAddress = result
    },

    // 处理方式变化
    handleTypeChange(e) {
      if (e.target.value === 0) {
        // 如果是维修，清空新设备MAC地址
        this.form.newMacAddress = ''
        // 清除MAC地址字段的验证
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate('newMacAddress')
        })
      } else {
        // 如果是换新，触发MAC地址字段的验证
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.validateField('newMacAddress')
        })
      }
    },

    // 取消按钮
    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },

    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        handleType: 0,
        newMacAddress: '',
        processorName: '',
        faultCause: '',
        repairContent: '',
        returnMailNo: '',
        remark: '',
      }
      this.$refs.form && this.$refs.form.clearValidate()
    },

    /** 打开抽屉 */
    init(record) {
      this.reset()
      this.form.id = record.id
      // 可以设置一些默认值，比如从记录中获取
      this.form.processorName = record.processorName || ''
      this.open = true
    },

    /** 提交表单 */
    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true

          // 如果是维修，不需要新设备MAC地址
          if (this.form.handleType === 0) {
            this.form.newMacAddress = ''
          }

          completeRepair(this.form)
            .then((response) => {
              this.$message.success('维修完成操作成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .catch(() => {
              // 错误处理
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop && this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>
